import getRetailerRegionByCountryCode from './getRetailerRegionByCountryCode';
import getRetailerSectorByItemGroupCode from './getRetailerSectorByItemGroupCode';
import { BannerMessages, RegionSectorToMessages } from './types';

enum RetailerRegionSector {
  EuropeMDA = 'EuropeMDA',
  EuropeSDA = 'EuropeSDA',
  EuropeConsumerElectronics = 'EuropeConsumer Electronics',
  EuropeITOffice = 'EuropeIT-Office',
  EuropeMobilePhone = 'EuropeMobile Phone',
  APAC1MDA = 'APAC 1MDA',
  APAC1ITOffice = 'APAC 1IT-Office',
  APAC1ConsumerElectronics = 'APAC 1Consumer Electronics',
  APAC2MDA = 'APAC 2MDA',
  APAC2SDA = 'APAC 2SDA',
  APAC2ITOffice = 'APAC 2IT-Office',
  APAC2ConsumerElectronics = 'APAC 2Consumer Electronics',
  APAC2MobilePhone = 'APAC 2Mobile Phone',
  LATAMSDA = 'LATAMSDA',
  LATAMMDA = 'LATAMMDA',
  LATAMITOffice = 'LATAMIT-Office',
  LATAMConsumerElectronics = 'LATAMConsumer Electronics',
  LATAMMobilePhone = 'LATAMMobile Phone',
  MiddleEastMDA = 'Middle EastMDA',
  MiddleEastSDA = 'Middle EastSDA',
  MiddleEastITOffice = 'Middle EastIT-Office',
  MiddleEastConsumerElectronics = 'Middle EastConsumer Electronics',
}

export const regionSectorToRLSMessages: RegionSectorToMessages<RetailerRegionSector> = {
  [RetailerRegionSector.EuropeMDA]: [
    {
      number: '68% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Great Britain MDA market',
    },
    {
      number: '6.0m lost shoppers',
      message: '...across the top five MDA retailers in Great Britain last year alone',
    },
    {
      number: '€7.4 million',
      message:
        '...a leading Washing Machine retailer in Great Britain could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '17% Store Seekers',
      message:
        '...make up the biggest proportion of the Great Britain MDA market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.EuropeSDA]: [
    {
      number: '67% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Great Britain SDA market',
    },
    {
      number: '5.3m lost shoppers',
      message: '...across the top five SDA retailers in Great Britain last year alone',
    },
    {
      number: '€2.1 million',
      message:
        '...a leading Vacuum Cleaner retailer in Great Britain could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '27% Pragmatics',
      message:
        '...make up the biggest proportion of the Great Britain SDA market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.EuropeITOffice]: [
    {
      number: '65% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the Great Britain IT-Office market',
    },
    {
      number: '3.8m lost shoppers',
      message: '...across the top five IT-Office retailers in Great Britain last year alone',
    },
    {
      number: '€3.1 million',
      message:
        '...a leading Laptop retailer in Great Britain could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '22% Brand Enthusiasts',
      message:
        '...make up the biggest proportion of the Great Britain IT-Office market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.EuropeConsumerElectronics]: [
    {
      number: '67% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Great Britain TV market',
    },
    {
      number: '3.5m lost shoppers',
      message: '...across the top five TV retailers in Great Britain last year alone',
    },
    {
      number: '€5.1 million',
      message:
        '...a leading TV retailer in Great Britain could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '19% Brand Agnostic Digitals',
      message:
        '...make up the biggest proportion of the Great Britain TV market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.EuropeMobilePhone]: [
    {
      number: '77% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the Great Britain Mobile Phone market',
    },
    {
      number: '5.7m lost shoppers',
      message: '...across the top five Mobile Phone retailers in Great Britain last year alone',
    },
    {
      number: '€7.3 million',
      message:
        '...a leading Mobile Phone retailer in Great Britain could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '28% High Spec Premiums',
      message:
        '...make up the biggest proportion of the Great Britain Mobile Phone market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC1MDA]: [
    {
      number: '54% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the India Washing Machine market',
    },
    {
      number: '8.4m lost shoppers',
      message: '...across the top five Washing Machines retailers in India last year alone',
    },
    {
      number: '€5.0 million',
      message:
        '...a leading Washing Machine retailer in India could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '26% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Indian Washing Machine market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC1ITOffice]: [
    {
      number: '31% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the India Vacuum Cleaner market',
    },
    {
      number: '9.7m lost shoppers',
      message: '...across the top five IT-Office retailers in India last year alone',
    },
    {
      number: '€9.4 million',
      message:
        '...a leading Laptop retailer in India could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '35% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Indian IT-Office market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC1ConsumerElectronics]: [
    {
      number: '59% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the India TV market',
    },
    {
      number: '11m lost shoppers',
      message: '...across the top five TV retailers in India last year alone',
    },
    {
      number: '€12 million',
      message:
        '...a leading TV retailer in India could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '23% Store Seekers',
      message:
        '...make up the biggest proportion of the Indian TV market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC2MDA]: [
    {
      number: '78% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the Japan Washing Machine market',
    },
    {
      number: '1.4m lost shoppers',
      message: '...across the top five Washing Machine retailers in Japan last year alone',
    },
    {
      number: '€2.3 million',
      message:
        '...a leading Washing Machine retailer in Japan could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '37% Store Seekers',
      message:
        '...make up the biggest proportion of the Japanese Washing Machine market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC2SDA]: [
    {
      number: '75% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Japan Vacuum Cleaner market',
    },
    {
      number: '1.3m lost shoppers',
      message: '...across the top five Vacuum Cleaner retailers in Japan last year alone',
    },
    {
      number: '€1.2 million',
      message:
        '...a leading Vacuum Cleaner retailer in Japan could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '28% Store Seekers',
      message:
        '...make up the biggest proportion of the Japanese Vacuum Cleaner market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC2ITOffice]: [
    {
      number: '65% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Japan IT-Office market',
    },
    {
      number: '1.8m lost shoppers',
      message: '...across the top five IT-Office retailers in Japan last year alone',
    },
    {
      number: '€1.8 million',
      message:
        '...a leading Laptop retailer in Japan could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '19% High Spec Premiums',
      message:
        '...make up the biggest proportion of the Japanese IT-Office market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC2ConsumerElectronics]: [
    {
      number: '73% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Japan TV market',
    },
    {
      number: '1.4m lost shoppers',
      message: '...across the top five TV retailers in Japan last year alone',
    },
    {
      number: '€3.5 million',
      message:
        '...a leading TV retailer in Japan could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '22% High Spec Premiums',
      message:
        '...make up one of the biggest proportions of the Japanese TV market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.APAC2MobilePhone]: [
    {
      number: '94% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Japan Mobile Phone market',
    },
    {
      number: '3.9m lost shoppers',
      message: '...across the top five Mobile Phone retailers in Japan last year alone',
    },
    {
      number: '€3.2 million',
      message:
        '...a leading Mobile Phone retailer in Japan could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '23% High Spec Premiums',
      message:
        '...make up the biggest proportion of the Japanese Mobile Phone market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.LATAMMDA]: [
    {
      number: '53% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the Brazil Washing Machine market',
    },
    {
      number: '7.1m lost shoppers',
      message: '...across the top five Washing Machines retailers in Brazil last year alone',
    },
    {
      number: '€5.9 million',
      message:
        '...a leading Washing Machine retailer in Brazil could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '28% Brand Enthusiasts',
      message:
        '...make up the biggest proportion of the Brazilian Washing Machine market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.LATAMSDA]: [
    {
      number: '55% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the Brazil Vacuum Cleaner market',
    },
    {
      number: '3.9m lost shoppers',
      message: '...across the top five Vacuum Cleaner retailers in Brazil last year alone',
    },
    {
      number: '€1.0 million',
      message:
        '...a leading Vacuum Cleaner retailer in Brazil could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '30% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Brazilian Vacuum Cleaner market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.LATAMITOffice]: [
    {
      number: '49% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Brazil IT-Office market',
    },
    {
      number: '5.3m lost shoppers',
      message: '...across the top five IT-Office retailers in Brazil last year alone',
    },
    {
      number: '€3.9 million',
      message:
        '...a leading Laptop retailer in Brazil could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '30% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Brazilian IT-Office market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.LATAMConsumerElectronics]: [
    {
      number: '55% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Brazil TV market',
    },
    {
      number: '11m lost shoppers',
      message: '...across the top five TV retailers in Brazil last year alone',
    },
    {
      number: '€11 million',
      message:
        '...a leading TV retailer in Brazil could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '24% Brand Enthusiasts',
      message:
        '...make up the biggest proportion of the Brazilian TV market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.LATAMMobilePhone]: [
    {
      number: '52% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Brazil Mobile Phone market',
    },
    {
      number: '25m lost shoppers',
      message: '...across the top five Mobile Phone retailers in Brazil last year alone',
    },
    {
      number: '€19 million',
      message:
        '...a leading Mobile Phone retailer in Brazil could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '25% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Brazilian Mobile Phone market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.MiddleEastMDA]: [
    {
      number: '60% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the Turkey Washing Machine market',
    },
    {
      number: '1.9m lost shoppers',
      message: '...across the top five Washing Machine retailers in Turkey last year alone',
    },
    {
      number: '€2.5 million',
      message:
        '...a leading Washing Machine retailer in Turkey could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '25% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Turkish Washing Machine market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.MiddleEastSDA]: [
    {
      number: '53% conversion',
      message:
        '...the highest conversion achieved by any of the top five retailers in the Turkey Vacuum Cleaner market',
    },
    {
      number: '3.7m lost shoppers',
      message: '...across the top five Vacuum Cleaner retailers in Turkey last year alone',
    },
    {
      number: '€3.5 million',
      message:
        '...a leading Vacuum Cleaner retailer in Turkey could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '33% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Turkish Vacuum Cleaner market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.MiddleEastITOffice]: [
    {
      number: '55% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Turkey IT-Office market',
    },
    {
      number: '3.0m lost shoppers',
      message: '...across the top five IT-Office retailers in Turkey last year alone',
    },
    {
      number: '€3.4 million',
      message:
        '...a leading Laptop retailer in Turkey could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '33% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Turkish IT-Office market but some leading retailers struggle to convert them',
    },
  ],
  [RetailerRegionSector.MiddleEastConsumerElectronics]: [
    {
      number: '56% conversion',
      message: '...the highest conversion achieved by any of the top five retailers in the Turkey TV market',
    },
    {
      number: '2.2m lost shoppers',
      message: '...across the top five TV retailers in Turkey last year alone',
    },
    {
      number: '€4.8 million',
      message:
        '...a leading TV retailer in Turkey could generate this much more in annual sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '27% Store Seekers',
      message:
        '...make up the biggest proportion of the Turkish TV market but some leading retailers struggle to convert them',
    },
  ],
};

export const getRLSBannerMessages = (market?: string, bannerIndex?: number): BannerMessages | undefined => {
  const [itemGroupCode, countryCode] = (market ?? '').split('/');
  if (!itemGroupCode || !countryCode) {
    return undefined;
  }

  const region = getRetailerRegionByCountryCode(countryCode);
  const sector = getRetailerSectorByItemGroupCode(itemGroupCode);
  if (!region || !sector) {
    return undefined;
  }

  const messages = regionSectorToRLSMessages[`${region}${sector}`];
  if (!messages) {
    return undefined;
  }

  return messages[bannerIndex ?? 0];
};
